<template>
<div class="slide-style">
    <div class="page__header">
        <div class="search-question" data-step="2">Select a style</div>
    </div>
    <div class="page__content">
        <div class="cooker__option" @click="filterByStyle('modern')">
            <img src="static/modern-cooker.png" alt="Modern Cooker"/>
            <p>Modern</p>
        </div>
        <div class="cooker__option" @click="filterByStyle('traditional')">
            <img src="static/traditional-cooker.png" alt="Traditional Cooker"/>
            <p>Traditional</p>
        </div>
    </div>
</div>
</template>
<script>
export default {
    methods: {
        filterByStyle(style){
            this.$ga.event('filter', 'style', style);
            this.$router.push({ name: 'fuel', params: { ...this.$route.params, style} })
        }
    },
  mounted(){
    this.$ga.screenview('style');
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/slide-2-style.vue